export default "__VITE_ASSET__2a1af6e8__"